import { queryOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type { LookupOption } from './model';

export const getHookTypeLookupQueryOptions = queryOptions({
  queryKey: ['脚本模版Hook类型选项'],
  queryFn: async () => {
    return http.get('lookups/hook-types').json<LookupOption[]>();
  },
});

export const getSellingPointLookupQueryOptions = queryOptions({
  queryKey: ['脚本模版卖点选项'],
  queryFn: async () => {
    return http.get('lookups/selling-points').json<LookupOption[]>();
  },
});

export const getScriptLanguageLookupQueryOptions = queryOptions({
  queryKey: ['脚本模版语言选项'],
  queryFn: async () => {
    return http.get('lookups/script-languages').json<LookupOption[]>();
  },
});
